export const DEFAULT_DEV_PARTNER_ID = '041d27e0-657b-11ef-9987-d93c4677d0a1'
export enum ExternalLink {
  refund = 'https://intickets.ru/refund/',
  resend = 'https://intickets.ru/resend/',
  oferta = 'https://intickets.ru/documents/oferta/',
  feedback = 'https://intickets.ru/requests/',
  clients = 'https://intickets.ru/our-clients/'
}
